import { render, staticRenderFns } from "./PromotionItem.vue?vue&type=template&id=40af588f&"
import script from "./PromotionItem.vue?vue&type=script&lang=js&"
export * from "./PromotionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports